import _validators from '@/utils/validators'

export const VALIDATORS = {
  birthday: {
    required: 'Campo obrigatório',
    validate: (value) => {
      if (!_validators.date(value)) return 'Data inválida'

      const date = value.split('/')

      const birthdayDate = new Date(date[2], date[1] - 1, date[0])
      const currentDate = new Date()

      const age = currentDate.getFullYear() - birthdayDate.getFullYear()

      return (age >= 18 && age <= 100) || 'Data inválida'
    }
  },
  cnpj: {
    required: 'Campo obrigatório',
    validate: (value) => _validators.cnpj(value) || 'CNPJ inválido'
  },
  cpf: {
    required: 'Campo obrigatório',
    validate: (value) => _validators.cpf(value) || 'CPF inválido'
  },
  email: {
    required: 'Campo obrigatório',
    validate: (value) => _validators.email(value) || 'Email inválido'
  },
  name: {
    required: 'Campo obrigatório',
    validate: (value) => _validators.name(value) || 'Nome inválido'
  },

  phone: {
    required: 'Campo obrigatório',
    validate: (value) => _validators.phone(value) || 'Telefone inválido'
  }
}
